import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	errorFlagTitle: {
		defaultMessage: 'Error',
		id: 'dashboard-edit.services.add-gadget.error-flag-title',
		description:
			'Text in notification flag to alert user that the operation to add gadget has failed',
	},
	errorFlagDescription: {
		defaultMessage: 'We cannot add any new gadgets at the moment',
		id: 'dashboard-edit.services.add-gadget.error-flag-description',
		description:
			'Text in notification flag to alert user that the operation to add gadget has failed',
	},
	errorFlagAction: {
		defaultMessage: 'Refresh',
		id: 'dashboard-edit.services.add-gadget.error-flag-action',
		description: 'Label for button inside the notification flag to reload the current page',
	},
	invalidColumnFlagTitle: {
		id: 'dashboard-edit.services.add-gadget.invalid-column-flag-title',
		defaultMessage: 'We couldn’t add the gadget',
		description:
			'Title text in notification flag to alert user that they are trying to add a gadget to a nonexistent column',
	},
});
